import * as theme from "../Variables";

import styled from "styled-components";

interface Body3Props {
  readonly info?: boolean;
  readonly bold?: boolean;
}

export const Body3 = styled.div<Body3Props>`
  font-family: "Inter", serif;
  font-weight: ${(props) => (props.bold ? "600" : "200")};
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.5px;
  color: ${(props) => (props.info ? theme.LIGHT_GRAY_COLOR : theme.BLACK_COLOR)};
`;
